<template>
  <t-form label-width="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="标题文本">
        <t-input v-model="attribute.title.text" size="small" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="标题大小">
        <t-input-number v-model="attribute.title.textStyle.fontSize" size="small" :min="2" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="标题颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.title.textStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="标题位置(X)">
        <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="标题位置(Y)">
        <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="x轴" :expand="false">
      <t-form-item label="x轴线颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLine.lineStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="x轴字体颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLabel.color" size="small"/>
      </t-form-item>
      <t-form-item label="x轴字号">
        <t-input-number v-model="attribute.xAxis.axisLabel.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="网格线">
        <t-switch v-model="attribute.xAxis.splitLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="网格线颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.splitLine.lineStyle.color" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="y轴" :expand="false">
      <t-form-item label="y轴颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLine.lineStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="y轴字体颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLabel.textStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="y轴字号">
        <t-input-number v-model="attribute.yAxis.axisLabel.textStyle.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="网格线">
        <t-switch v-model="attribute.yAxis.splitLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="网格线颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.splitLine.lineStyle.color" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="数值" :expand="true">
      <t-form-item label="数值显示">
        <t-switch v-model="attribute.series.label.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="数值字体">
        <t-input-number v-model="attribute.series.label.fontSize" :min="2" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="数值颜色" v-show="attribute.series.label.color">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.series.label.color" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="折线" :expand="true">
      <t-form-item label="深度">
        <t-input-number v-model="attribute.boxDepth" :min="2" :max="150" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="宽度">
        <t-input-number v-model="attribute.series.lineStyle.width" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="圆点大小">
        <t-input-number v-model="attribute.series.symbolSize" :min="1" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="配色">
        <e-color-group v-model="attribute.color" :max="20"/>
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script setup>
import { ref } from 'vue'
import EColorGroup from "@/components/designer/e-color-group.vue";
import EChartPosition from "@/components/designer/e-chart-position.vue";
import CptData from '@/components/element/options/comp/cpt-data'
const currentComponent = ref('CptData')
const props = defineProps({
  attribute:Object,
  cptDataForm:Object,
})
</script>
<style scoped>

</style>